import PropTypes from 'prop-types';
import SubscribeEventsToggleImpl from './subscribe-events-toggle.jsx';
import MojitoCore from 'mojito/core';

/**
 * SubscribeEventsToggle component. Child component for EventNotificationSubscriber, will show specific content in a popup depending if its from event details or bet receipt page.
 *
 * @class SubscribeEventsToggle
 * @memberof Mojito.Modules.EventNotifications
 */

/**
 * SubscribeEventsToggle prop types.
 *
 * @property {boolean} [hideBellIcon = false] - Indicates if bell icon should be rendered on a view.
 * @property {string} [l10nKeyLabel] - Translation key that will be used to resolve description text.
 * @property {Array<string>} eventIds - Event ids.
 *
 * @memberof Mojito.Modules.EventNotifications.SubscribeEventsToggle
 */
const propTypes = {
    hideBellIcon: PropTypes.bool,
    l10nKeyLabel: PropTypes.string,
    eventIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const defaultProps = {
    hideBellIcon: false,
};

export default MojitoCore.Presentation.UIView(
    'SubscribeEventsToggle',
    SubscribeEventsToggleImpl,
    propTypes,
    defaultProps
);
